import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../services/user/user.service";

@Component({
  selector: 'sb-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router, private userService: UserService) { }

  async ngOnInit() {
    let targetPage = this.userService.getHome();
    let storedHomePage = this.userService.getUserProfileProperty("user.home.page", "");

    if (targetPage.length > 0) {
      targetPage = targetPage.startsWith("#") ? targetPage.substring(1) : targetPage;
    }

    if (storedHomePage.length > 0) {
      targetPage = storedHomePage.startsWith("#") ? storedHomePage.substring(1) : storedHomePage;
    }

    console.debug(`HomePageComponent: storedHomePage = ${storedHomePage}, going to ${targetPage}`);
    await this.router.navigateByUrl(targetPage);
  }

}
